var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-0"},[_c('h1',{staticClass:"mb-6 text-center text-lg font-semibold text-textBlue dark:text-gray-100"},[_vm._v("COURSES")]),_c('CourseContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }